import React, { useState, useEffect, useCallback, createContext, useContext } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustBar from "./components/TrustBar";
import Services from "./components/Services";
import Technology from "./components/Technology";
import Gallery from "./components/Gallery";
import Procedures from "./components/Procedures";
import Doctor from "./components/Doctor";
import Exams from "./components/Exams";
import Lucia from "./components/Lucia";
import Testimonials from "./components/Testimonials";
import Alianza from "./components/Alianza";
import PanelCTA from "./components/PanelCTA";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import LuciaButton from "./components/LuciaButton";
import ReservaModal from "./components/ReservaModal";
import { Toaster } from "./components/ui/toaster";

export const BookingContext = createContext({ openBooking: () => {} });
export const useBooking = () => useContext(BookingContext);

// Scroll reveal
const useScrollReveal = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  });
};

const Home = () => {
  useScrollReveal();
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <Technology />
        <Gallery />
        <Procedures />
        <Doctor />
        <Exams />
        <Lucia />
        <Testimonials />
        <Alianza />
        <Contact />
        <PanelCTA />
      </main>
      <Footer />
      <WhatsAppButton />
      <LuciaButton />
    </>
  );
};

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const openBooking = useCallback(() => setBookingOpen(true), []);

  return (
    <div className="App">
      <BookingContext.Provider value={{ openBooking }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <ReservaModal open={bookingOpen} onOpenChange={setBookingOpen} />
        <Toaster />
      </BookingContext.Provider>
    </div>
  );
}

export default App;
